import { NarrowFilter } from "../../../components";
import styled from "styled-components";

export const StyledSearchBar = styled(NarrowFilter)`
  margin-top: ${({ theme }) => theme.space.lg};
  margin-bottom: ${({ theme }) => theme.space.xs};
`;
